import { NumberFilter, OptionFilter } from '@common/searchFilter/searchFilter.models';
import { IProjectCompany } from '@company/projectCompany/projectCompany.models';
import { IRiskCategory } from '@riskCategory/riskCategory.models';
import { IProjectUserProfile } from '@userProfile/projectUserProfile.models';
import { EProjectRequestStatus } from './projectRequest.constants';
import {
  IProjectRequestCompany,
  IUpsertProjectRequestCompanyRequest,
} from './projectRequestCompany/projectRequestCompany.models';

export interface IProjectRequest {
  id: number;
  projectNo?: string;
  projectName?: string;
  typeId: number;
  regionId: number;
  address?: string;
  description?: string;
  tel?: string;
  fax?: string;
  email?: string;
  siteAdminProfileId: number;
  startDate: string;
  finishDate: string;
  status: EProjectRequestStatus;
  remark?: string;
  submittedBy: number;
  submittedDate: string;
  approvedBy: number;
  approvedDate: string;
  processedBy: number;
  processedDate: string;
  rowVersion?: string;
}

export interface IUpsertProjectRequestRequest {
  projectNo: string;
  projectName: string;
  typeId: number;
  regionId: number;
  address?: string;
  description?: string;
  telephone?: string;
  fax?: string;
  email?: string;
  startDate: string;
  endDate: string;
  status: number;
  remark?: string;
  projectRequest_Company?: IUpsertProjectRequestCompanyRequest[];
  rowVersion?: string;
  id?: number;
}

export interface IProjectRequestFormProjectCompany extends IProjectCompany {
  isDefault?: boolean;
}

export enum EProjectRequestFormKeys {
  PROJECT_NO = 'projectNo',
  PROJECT_TYPE = 'typeId',
  PROJECT_REGION = 'regionId',
  PROJECT_TITLE = 'projectName',
  ADDRESS = 'address',
  DESCRIPTION = 'description',
  TEL = 'tel',
  FAX = 'fax',
  EMAIL = 'email',
  START_DATE = 'startDate',
  END_DATE = 'finishDate',
  STATUS = 'status',
  REMARK = 'remark',
  SUBMITTED_BY = 'submittedBy',
  SUBMITTED_DATE = 'submittedDate',
  COMPANIES = 'projectRequest_Company',
  TEAMS = 'projectRequest_Team',
  USERS = 'projectRequest_User',
  ROLES = 'roles',
  COMPANY_ORGANIZATION_TYPE_ID = 'organizationTypeId',
  COMPANY_MAX_RISK_CATEGORY = 'maxRiskCategory',
  COMPANY_TYPE_ID = 'companyTypeId',
}

export interface IProjectRequestFormState {
  [EProjectRequestFormKeys.PROJECT_NO]: string | null;
  [EProjectRequestFormKeys.PROJECT_TYPE]: {
    id: number;
    type: string;
  } | null;
  [EProjectRequestFormKeys.PROJECT_REGION]: {
    id: number;
    region: string;
  } | null;
  [EProjectRequestFormKeys.PROJECT_TITLE]: string | null;
  [EProjectRequestFormKeys.ADDRESS]: string | null;
  [EProjectRequestFormKeys.DESCRIPTION]: string | null;
  [EProjectRequestFormKeys.TEL]: string | null;
  [EProjectRequestFormKeys.FAX]: string | null;
  [EProjectRequestFormKeys.EMAIL]: string | null;
  [EProjectRequestFormKeys.START_DATE]: string;
  [EProjectRequestFormKeys.END_DATE]: string;
  [EProjectRequestFormKeys.REMARK]: string | null;
  [EProjectRequestFormKeys.COMPANIES]: IProjectRequestCompanyFormState[];
}

export interface IProjectRequestCompanyFormState extends Omit<IProjectRequestCompany, 'maxRiskCategory'> {
  isDefault: boolean;
  maxRiskCategory?: IRiskCategory | string;
  roles?: { [key: string]: IProjectUserProfile[] };
}
export interface IProjectRequestSearchFilter {
  profileId: NumberFilter;
  status?: OptionFilter;
}

export const projectRequestSearchKeys = {
  STATUS: 'status',
};

export const ProjectRequestStatusOptions = [
  { key: EProjectRequestStatus.DRAFT, text: 'Draft' },
  { key: EProjectRequestStatus.ENDORSED, text: 'Endorsed' },
  { key: EProjectRequestStatus.ENDORSED_AND_REVISED, text: 'Endorsed and Revised' },
  { key: EProjectRequestStatus.APPROVED, text: 'Approved' },
  { key: EProjectRequestStatus.PROCESSED, text: 'Processed' },
  { key: EProjectRequestStatus.REJECTED, text: 'Rejected' },
  { key: EProjectRequestStatus.CURRENT_PROJECT, text: 'Current Project' },
];

export const mockDataProjectType = [
  { id: 1, type: 'Building' },
  { id: 3, type: 'Civil' },
  { id: 4, type: 'Foundations' },
  { id: 5, type: 'E&M' },
  { id: 7, type: 'Concrete' },
  { id: 8, type: 'Steelwork' },
  { id: 9, type: 'Tender' },
];

export const mockDataProjectRegion = [
  { id: 1, region: 'Hong Kong' },
  { id: 2, region: 'China' },
  { id: 3, region: 'Macau' },
  { id: 4, region: 'Singapore' },
];

export enum EProjectRequestLeftNavBtnKey {
  PRIMARY,
  SECONDARY,
  REJECT,
  CANCEL,
}
